define(['edge/platform/base/BaseCtrl', 'underscore'], (BaseCtrl, _)=> {
    const fn = function ($scope, StateUtils) {
        const ctrl = Object.create(BaseCtrl);
        const { flowModel } = StateUtils.activeDataForState(true);
        /**
         * Method used by wizard ribbon set styles for active and visited steps in the wizard flow
         */
        function refreshStepsFn() {
            function setStepClasses(wizardSteps) {
                if (wizardSteps.length > 0) {
                    const currentStateIdx = _.findIndex(wizardSteps, step => step.name === flowModel.currentStep.name);

                    for (let stepIdx = 0; stepIdx < wizardSteps.length; stepIdx++) {
                        const step = wizardSteps[stepIdx];
                        const visited = stepIdx < currentStateIdx;//b036149 = removed, because of wrong behaviour, actual page is current no other class necessary
                        const activeClass = currentStateIdx === stepIdx ? 'gw-current' : '';
                        // b036149 unusful class, is current and no other class necessary
                        // following pages are handlet with allowedVisitClass, original Code: (visited || stepIdx === 0) ? '' : 'gw-not-visited';
                        const notVisitedClass = '';
                        const visitedClass = (visited) ? 'gw-visited' : '';
                        const allowedVisitClass = flowModel.isStepAccessibleFromCurrent(step) ? '' : 'gw-not-allowed';
                        step.styleClass = `${activeClass} ${notVisitedClass} ${visitedClass} ${allowedVisitClass}`;
                    }
                }
            }

            $scope.wizardSteps.length = 0;
            Array.prototype.push.apply($scope.wizardSteps, flowModel.steps);
            $scope.ribbonVisible = $scope.wizardSteps.length > 0;
            setStepClasses($scope.wizardSteps);
        }

        ctrl.init = function () {
            if (!flowModel) {
                return;
            }
            $scope.wizardSteps = [];
            $scope.ribbonVisible = false;
            refreshStepsFn();

            flowModel.addStepChangeListener(refreshStepsFn);

            $scope.$on('$destroy', ()=> {
                flowModel.removeStepChangeListener(refreshStepsFn);
            });
        };

        /**
         * Method used by wizard ribbon to move between steps.
         * @param {Object} step - selected step
         */
        ctrl.selectStep = function (step) {
            const currentModel = flowModel.snapshot || StateUtils.activeDataForState(true).model;

            if (flowModel.isStepAccessibleFromCurrent(step)) {
                flowModel.jumpToStep(step, currentModel);
            }
        };

        ctrl.stepLabel = function (step) {
            return step.label();
        };

        ctrl.isVisited = (step) => {
            const uiStepIndex = $scope.wizardSteps.findIndex(actStep => actStep.name === step.name);
            const currentStepIndex = $scope.wizardSteps.findIndex(actStep => actStep.name === flowModel.currentStep.name);
            return uiStepIndex < currentStepIndex;
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', 'StateUtils'];

    return fn;
});


// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/widgets/wizard/_WizardStepsCtrl.js